<template>
  <div>
    <div
      :class="{
        ['hi-lo-bet-lot-cell-' + type]: type,
        'hi-lo-bet-lot-cell-active': win,
        [size]: size
      }"
    >
      <div class="hi-lo-bet-lot-title" :class="{ [size]: size }">
        <span v-html="$t(`hi_lo.${type}`)"></span>
      </div>
      <div
        class="hi-lo-bet-lot-bet-no"
        :class="{ [size]: size }"
        type="flex"
        justify="center"
      >{{ odd }}</div>
      <div v-if="stakeRecordSum" class="hi-lo-bet-lot-stake-total">{{ stakeRecord }}</div>
    </div>
  </div>
</template>

<script>
import { Row } from "iview";
import { snakeCase } from "change-case";

export default {
  props: ["type", "odd", "win", "game", "size", "stakeRecordSum"],
  components: {
    Row
  },
  computed: {
    gameSnakeCase() {
      return snakeCase(this.game);
    },
    stakeRecord() {
      return display_numeric(this.stakeRecordSum);
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.hi-lo-bet-lot-cell {
  position: relative;
  padding: 0;
  width: 100%;
  margin-bottom: -20px;
  border-radius: 5px;
  border: 2px solid #4d4d4d;
  text-align: center;
  text-align: center;
  background-image: linear-gradient(#333333, #676767);
}

// @keyframes float {
//   0% {
//     transform: translatey(0px);
//   }
//   50% {
//     transform: translatey(-5px);
//   }
//   100% {
//     transform: translatey(0px);
//   }
// }

.hi-lo-bet-lot-cell-o1 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 50px;
  border-radius: 8px;
  text-align: left;
  border: 5px solid #212121;
  background: #2b2b2b;
  position: relative;
  padding-left: 50px;
  cursor: pointer; //1017 ADDED
}

.hi-lo-bet-lot-cell-o1:before {
  content: "";
  position: absolute;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  left: 5px;
  background: #46525d;
  background: -moz-linear-gradient(top, #46525d 0%, #1d1714 100%);
  background: -webkit-linear-gradient(top, #46525d 0%, #1d1714 100%);
  background: linear-gradient(to bottom, #46525d 0%, #1d1714 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#46525d', endColorstr='#1d1714',GradientType=0 );
  border: 2px solid #ffc64e;
}

.hi-lo-bet-lot-cell-o1:after {
  content: "";
  position: absolute;
  left: 12px;
  top: 5px;
  background-image: url("../../../assets/images/hi-lo/hilo-up.png");
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 25px;
  height: 25px;
  // animation: float 6s ease-in-out infinite;
}

// .hi-lo-bet-lot-cell-o2 {
//   @extend .tai-xiu-game-cell;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   flex-direction: column;
//   width: 100%;
//   height: 50px;
//   text-align: center;
//   background-image: url("../../../assets/images/hi-lo/LoButton.png");
//   background-size: contain;
//   background-repeat: no-repeat;
//   background-position: center;
// }

.hi-lo-bet-lot-cell-o2 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 50px;
  border-radius: 8px;
  text-align: left;
  border: 5px solid #212121;
  background: #2b2b2b;
  position: relative;
  padding-left: 50px;
  cursor: pointer; //1017 ADDED
}

.locale_2 .hi-lo-bet-lot-cell-o1,
.locale_2 .hi-lo-bet-lot-cell-o2,
.locale_3 .hi-lo-bet-lot-cell-o1,
.locale_3 .hi-lo-bet-lot-cell-o2,
.locale_5 .hi-lo-bet-lot-cell-o1,
.locale_5 .hi-lo-bet-lot-cell-o2 {
  font-size: 12px;
}

.hi-lo-bet-lot-cell-o2:before {
  content: "";
  position: absolute;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  left: 5px;
  background: #46525d;
  background: -moz-linear-gradient(top, #46525d 0%, #1d1714 100%);
  background: -webkit-linear-gradient(top, #46525d 0%, #1d1714 100%);
  background: linear-gradient(to bottom, #46525d 0%, #1d1714 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#46525d', endColorstr='#1d1714',GradientType=0 );
  border: 2px solid #ffc64e;
}

.hi-lo-bet-lot-cell-o2:after {
  content: "";
  position: absolute;
  left: 12px;
  top: 9px;
  background-image: url("../../../assets/images/hi-lo/hilo-down.png");
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 25px;
  height: 25px;
  // animation: float 3s ease-in-out infinite;
}

.hi-lo-bet-lot-cell.small {
  padding-top: 10px;
  padding-bottom: 6px;
}

.hi-lo-bet-lot-cell:first-of-type {
  margin-left: unset;
}

.hi-lo-bet-lot-cell:last-of-type {
  margin-right: unset;
}

.hi-lo-bet-lot-title {
  color: #dcad58;
  width: 100%;
}

.hi-lo-bet-lot-title.small {
  height: unset;
  margin-top: 15px;
}

.hi-lo-bet-lot-bet-no {
  width: 100%;
}

.hi-lo-bet-lot-cell-o1 .hi-lo-bet-lot-bet-no {
  font-size: 12px;
  color: #fff;
}

.hi-lo-bet-lot-cell-o2 .hi-lo-bet-lot-bet-no {
  font-size: 12px;
  color: #fff;
}

.hi-lo-bet-lot-bet-no.small {
  height: unset;
}
</style>

<style lang="scss">
.hi-lo-bet-lot-cell {
  @extend .tai-xiu-game-btn;
}

.hi-lo-bet-lot-cell-o1.hi-lo-bet-lot-cell-active .hi-lo-bet-lot-title,
.hi-lo-bet-lot-cell-o1.hi-lo-bet-lot-cell-active .hi-lo-bet-lot-bet-no,
.hi-lo-bet-lot-cell-o2.hi-lo-bet-lot-cell-active .hi-lo-bet-lot-title,
.hi-lo-bet-lot-cell-o2.hi-lo-bet-lot-cell-active .hi-lo-bet-lot-bet-no {
  @extend .tai-xiu-game-btn-active;
}

.hi-lo-bet-lot-cell:hover {
  @extend .tai-xiu-game-btn-hover;
}

.hi-lo-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-size: 11px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-bottom-left-radius: 8px;
  max-height: 16px;
  line-height: 16px;
}

@media only screen and (max-width: 360px) {
  .hi-lo-bet-lot-cell {
    padding: 6px 0;
  }

  .hi-lo-bet-lot-cell.large {
    padding-bottom: 6px;
  }

  .hi-lo-bet-lot-title.large {
    height: 32px;
  }

  .hi-lo-bet-lot-bet-no.large,
  .hi-lo-bet-lot-bet-no.small {
    margin-top: 6px;
  }
}
</style>
